/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationCountriesCountryidLangsId200,
  GetApiV1LocationCountriesCountryidLangsId401,
  GetApiV1LocationCountriesCountryidLangsId404,
  GetApiV1LocationCountriesCountryidLangsId500,
  GetApiV1LocationCountriesCountryidLangsIdPathParams,
  GetApiV1LocationCountriesCountryidLangsIdQueryResponse,
} from "../../types/locationCountryLangController/GetApiV1LocationCountriesCountryidLangsId.ts";
import { countryLangViewModelSchema } from "../countryLangViewModelSchema.ts";

export const getApiV1LocationCountriesCountryidLangsIdPathParamsSchema =
  z.object({
    countryId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationCountriesCountryidLangsId200Schema = z.lazy(
  () => countryLangViewModelSchema,
) as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationCountriesCountryidLangsId401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1LocationCountriesCountryidLangsId404Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationCountriesCountryidLangsId500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsId500>;

export const getApiV1LocationCountriesCountryidLangsIdQueryResponseSchema =
  z.lazy(
    () => getApiV1LocationCountriesCountryidLangsId200Schema,
  ) as unknown as ToZod<GetApiV1LocationCountriesCountryidLangsIdQueryResponse>;
